// extracted by mini-css-extract-plugin
module.exports = {"backgroundFullWidth":"background-full-width_backgroundFullWidth__sAnFx"};